<template>
  <div class="err_page">
    <img src="images/404.png" alt="" />
    <p style="color: #6B798E; font-size: 14px">
      对不起，您没有足够的权限。
    </p>
    <div class="err_page_btn">
      <el-button type="text" @click="$router.go(-1)">返回上一页</el-button>
      <!-- <el-button type="text" @click="$router.push({name: 'Index'})">返回首页</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Err',
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.err_page {
  background: #fff;
  height: 100%;
  width: 100%;
  -moz-background-size: cover;
  background-position: center center;
  background-size: cover;
  text-align: center;
  overflow: hidden;

  p {
    font-size: 16px;
    margin: 20px;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    margin-top: 5%;
  }

  .err_page_btn {
    .el-button {
      color: #3973ff;
    }
  }
}
</style>
